<template>
  <div v-if="recentlyViewedProducts.length" class="rv__wrapper">
    <h3 v-if="!sourceEop" class="section__label">Recently Viewed</h3>
    <RecentlyViewed
      :products="recentlyViewedProducts"
      :sourceEop="sourceEop"
    />
  </div>
</template>

<script setup>
import { onBeforeMount, ref } from 'vue';
import RecentlyViewed from './recently-viewed.vue'

const props = defineProps({
  currentProductHandle: {
    type: String,
    required: true,
  },
  sourceEop: {
    type: String,
    required: false,
  }
})

onBeforeMount(async() => {
  await recentlyViewedProductHandles.forEach((handle) => {
    fetch(`/products/${handle}?view=json`)
    .then(resp => resp.json())
    .then(data => {
      recentlyViewedProducts.value.push(data)
    }) 
  })
})

const recentlyViewedProducts = ref([])
const recentlyViewedProductHandles = JSON.parse(localStorage.getItem('recentlyViewedProducts') || '[]').filter(handle => handle !== props.currentProductHandle)
</script>